module.exports = __webpack_public_path__ + "img/QuilityLogoHorizontalWhiteRGB_B.23adae07.svg";